/* eslint-disable react/require-default-props */
import React from 'react';

interface IconProps {
  size?: number;
}

export const CheckIcon = ({ size = 14 }: IconProps) => (
  <svg viewBox="0 0 24 24" width={size} height={size} aria-hidden="true">
    <path
      d="M5 12.5l4.5 4.5L19 7.5"
      fill="none"
      stroke="currentColor"
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const XIcon = ({ size = 14 }: IconProps) => (
  <svg viewBox="0 0 24 24" width={size} height={size} aria-hidden="true">
    <path
      d="M6 6l12 12M18 6L6 18"
      fill="none"
      stroke="currentColor"
      strokeWidth="3"
      strokeLinecap="round"
    />
  </svg>
);

export const ChatIcon = ({ size = 22 }: IconProps) => (
  <svg viewBox="0 0 24 24" width={size} height={size} aria-hidden="true">
    <path
      d="M4 5h16v11H8l-4 4V5z"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinejoin="round"
    />
  </svg>
);

export const ShieldIcon = ({ size = 18 }: IconProps) => (
  <svg viewBox="0 0 24 24" width={size} height={size} aria-hidden="true">
    <path
      d="M12 3l8 3v6c0 4.5-3.4 8.4-8 9-4.6-.6-8-4.5-8-9V6l8-3z"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinejoin="round"
    />
  </svg>
);

export const CardIcon = ({ size = 18 }: IconProps) => (
  <svg viewBox="0 0 24 24" width={size} height={size} aria-hidden="true">
    <rect
      x="3"
      y="6"
      width="18"
      height="12"
      rx="2"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.6"
    />
    <path d="M3 10h18" stroke="currentColor" strokeWidth="1.6" />
  </svg>
);

export const LockIcon = ({ size = 18 }: IconProps) => (
  <svg viewBox="0 0 24 24" width={size} height={size} aria-hidden="true">
    <rect
      x="5"
      y="11"
      width="14"
      height="9"
      rx="2"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.6"
    />
    <path d="M8 11V8a4 4 0 018 0v3" fill="none" stroke="currentColor" strokeWidth="1.6" />
  </svg>
);

export const HeartIcon = ({ size = 18 }: IconProps) => (
  <svg viewBox="0 0 24 24" width={size} height={size} aria-hidden="true">
    <path
      d="M12 20s-7-4.4-7-10a4 4 0 017-2.6A4 4 0 0119 10c0 5.6-7 10-7 10z"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinejoin="round"
    />
  </svg>
);

export const ArrowRightIcon = ({ size = 16 }: IconProps) => (
  <svg viewBox="0 0 24 24" width={size} height={size} aria-hidden="true">
    <path
      d="M5 12h14M13 6l6 6-6 6"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const LegalIllustration = () => (
  <svg viewBox="0 0 240 200" width="100%" height="100%">
    <ellipse cx="120" cy="170" rx="90" ry="14" fill="#C9EFDB" opacity="0.5" />
    <g transform="translate(60 30)">
      <path d="M60 40 L90 50 L90 130 L60 140 L30 130 L30 50 Z" fill="#1FA56B" />
      <path d="M60 40 L60 140" stroke="#0F6E47" strokeWidth="2" />
      <path
        d="M40 70 L80 70 M40 90 L80 90 M40 110 L70 110"
        stroke="#fff"
        strokeWidth="3"
        strokeLinecap="round"
      />
    </g>
    <g transform="translate(20 60)">
      <circle cx="20" cy="20" r="20" fill="#34C285" />
      <path
        d="M12 22 l6 6 l12 -14"
        fill="none"
        stroke="#fff"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <g transform="translate(180 70)">
      <circle cx="20" cy="20" r="20" fill="#0F6E47" />
      <path d="M20 12 v16 M12 20 h16" stroke="#fff" strokeWidth="3" strokeLinecap="round" />
    </g>
  </svg>
);

export const CourseIllustration = () => (
  <svg viewBox="0 0 240 200" width="100%" height="100%">
    <ellipse cx="120" cy="170" rx="90" ry="14" fill="#C9EFDB" opacity="0.5" />
    <g transform="translate(40 40)">
      <rect x="0" y="0" width="160" height="100" rx="10" fill="#0F1A2E" />
      <rect x="6" y="6" width="148" height="88" rx="6" fill="#1FA56B" opacity="0.18" />
      <circle cx="80" cy="50" r="22" fill="#1FA56B" />
      <path d="M73 40 L93 50 L73 60 Z" fill="#fff" />
      <rect x="60" y="105" width="40" height="6" rx="3" fill="#0F1A2E" />
    </g>
    <g transform="translate(160 24)">
      <circle cx="14" cy="14" r="14" fill="#34C285" />
      <path d="M14 8 v12 M8 14 h12" stroke="#fff" strokeWidth="2" strokeLinecap="round" />
    </g>
  </svg>
);
